import React from "react";
import introVideo from '../../view/Arctic Monkeys.mp4'

import "./video.css";
export function Video(){
  return (
    <div className="container-div-video" style={{ userSelect: 'none', WebkitUserSelect: 'none'}}  >
        <video src={introVideo} controls={true} autoPlay={true} muted={true} preload="metadata" loop={true} type="mp4" />
    </div>
  );
}
